import status from "../constants/actionStatus";

export default (
    state = {
        courseContent: {},
    },
    action = {}
) => {
    switch (action.type) {
    case "COURSE_CONTENT_REQUEST":
        return {
            status: status.PENDING,
            courseContent: {},
        };
    case "COURSE_CONTENT_SUCCESS":
        return {
            status: status.SUCCESS,
            courseContent: action.payload,
        };

    case "COURSE_CONTENT_FAILURE":
        return {
            status: status.ERROR,
            courseContent: {},
        };
    default:
        return state;
    }
};
